var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45078 6.1002C6.94195 6.1002 8.15078 4.89136 8.15078 3.4002C8.15078 1.90903 6.94195 0.700195 5.45078 0.700195C3.95961 0.700195 2.75078 1.90903 2.75078 3.4002C2.75078 4.89136 3.95961 6.1002 5.45078 6.1002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45078 7.9002C8.43312 7.9002 10.8508 10.3179 10.8508 13.3002H0.0507812C0.0507812 10.3179 2.46844 7.9002 5.45078 7.9002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6508 4.3002C12.6508 3.80314 12.2478 3.4002 11.7508 3.4002C11.2537 3.4002 10.8508 3.80314 10.8508 4.3002V5.2002H9.95078C9.45373 5.20019 9.05078 5.60314 9.05078 6.1002C9.05078 6.59725 9.45372 7.0002 9.95078 7.0002H10.8508V7.9002C10.8508 8.39725 11.2537 8.8002 11.7508 8.8002C12.2478 8.8002 12.6508 8.39725 12.6508 7.9002V7.0002H13.5508C14.0478 7.0002 14.4508 6.59725 14.4508 6.1002C14.4508 5.60314 14.0478 5.2002 13.5508 5.2002H12.6508V4.3002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.6817b471e7f10be577e310f66b3e9de5.svg";
export { ForwardRef as ReactComponent };